module.exports = __webpack_public_path__ + "static/icon-carrier-agnostic@3x.9d24b050.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-carrier-agnostic@3x.png
// module id = 231
// module chunks = 168707334958949